export const STRUT_TYPE_COLORS = {
    'MLG-R': { bg: 'rgba(4, 106, 56, 0.8)', border: 'rgba(4, 106, 56, 1)' },
    'MLG-L': { bg: 'rgba(83, 87, 90, 0.8)', border: 'rgba(83, 87, 90, 1)' },
    NLG: { bg: 'rgba(0, 123, 255, 0.8)', border: 'rgba(0, 123, 255, 1)' },
    Other: { bg: 'rgba(108, 117, 125, 0.8)', border: 'rgba(108, 117, 125, 1)' },
};

export const STRUT_TYPE_LABELS = {
    'MLG-L': 'Left (MLG-L)',
    'MLG-R': 'Right (MLG-R)',
    NLG: 'Nose (NLG)',
    Other: 'Other',
};

export const STRUT_TYPE_ORDER = ['MLG-L', 'MLG-R', 'NLG', 'Other'];

export const STRUT_PN_PREFIX = '133-8';

export function isStrutPartNumber(pn) {
    return String(pn || '').trim().toUpperCase().startsWith(STRUT_PN_PREFIX);
}

export function getStrutType(nomen, posCd) {
    const n = (nomen || '').toUpperCase();
    if (n.includes('/R/')) return 'MLG-R';
    if (n.includes('/L/')) return 'MLG-L';
    if (n.includes('NOSE')) return 'NLG';
    const p = (posCd || '').toUpperCase();
    if (p === '13BAE') return 'MLG-R';
    if (p === '13BA0') return 'MLG-L';
    if (p === '13ABB') return 'NLG';
    return 'Other';
}

export function processStrutWaterfallData(rows) {
    const items = (rows || [])
        .filter(r => r.usg_remng_qty != null && r.buno && isStrutPartNumber(r.pn))
        .map(r => {
            const strutType = getStrutType(r.nomen, r.pos_cd);
            const remaining = parseFloat(r.usg_remng_qty) || 0;
            const colors = STRUT_TYPE_COLORS[strutType] || STRUT_TYPE_COLORS.Other;
            const buno = String(r.buno).trim();
            return {
                buno,
                modex: r.modex,
                nomen: r.nomen,
                pn: r.pn,
                posCd: r.pos_cd,
                strutType,
                remaining,
                schdExpndtr: r.schd_expndtr,
                label: `${buno} (${strutType})`,
                backgroundColor: colors.bg,
                borderColor: colors.border,
            };
        });

    items.sort((a, b) => a.remaining - b.remaining);

    const strutTypeSet = new Set(items.map(i => i.strutType));
    const strutTypeColors = {};
    strutTypeSet.forEach(type => {
        strutTypeColors[type] = STRUT_TYPE_COLORS[type] || STRUT_TYPE_COLORS.Other;
    });

    return buildStrutWaterfallChart(items, strutTypeColors);
}

export function buildStrutWaterfallChart(items, strutTypeColors = null) {
    const colors = strutTypeColors || {};
    items.forEach(item => {
        if (!colors[item.strutType]) {
            colors[item.strutType] = STRUT_TYPE_COLORS[item.strutType] || STRUT_TYPE_COLORS.Other;
        }
    });

    return {
        labels: items.map(i => i.label),
        datasets: [{
            label: 'Usage Remaining',
            data: items.map(i => i.remaining),
            backgroundColor: items.map(i => i.backgroundColor),
            borderColor: items.map(i => i.borderColor),
            borderWidth: 2,
        }],
        items,
        strutTypeColors: colors,
    };
}
